<template>
  <main>
    <div class="container-fluid pt-3">

      <div class="card shadow-lg ">
        <div class="card-body p-3">
          <div class="row gx-4">
            <div class="col my-auto">
              <div class="h-100">
                <h5 class="mb-1">시스템지갑</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="py-4 container-fluid">
      <div class="row">
        <div class="col-md-12  mb-4">
          <div class="card">
            <div class="card-body">
              <p class="text-uppercase text-sm">시스템 지갑주소</p>
              <div class="row">
                <div class="col-md-12">
                  <label for="example-text-input" class="form-control-label">지갑주소</label>
                  <input class="form-control" type="text" v-model="s_address" readonly />
                </div>
              </div>
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="example-text-input" class="form-control-label">지갑 보유개수[TRON]</label>
                    <div class="input-group">
                      <input class="form-control" type="text" v-model="s_tron_balance" readonly />
                      <button type="button"  class="btn btn-sm mb-0" @click="CheckBalance()">
                        <i class="fa fa-refresh"></i>
                      </button>
                      <button type="button"  class="btn btn-sm mb-0" data-bs-toggle="modal" data-bs-target="#system_tron_add" @click="SendEmail()">
                        <i class="fa fa-plus"></i>
                      </button>
                      <button type="button"  class="btn btn-sm mb-0" data-bs-toggle="modal" data-bs-target="#system_tron_minus" @click="SendEmail()">
                        <i class="fa fa-minus"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="example-text-input" class="form-control-label">지갑 보유개수[USDT]</label>
                    <div class="input-group">
                      <input class="form-control" type="text" v-model="s_usdt_balance" readonly />
                      <button type="button"  class="btn btn-sm mb-0" @click="CheckBalance()">
                        <i class="fa fa-refresh"></i>
                      </button>
                      <button type="button"  class="btn btn-sm mb-0" data-bs-toggle="modal" data-bs-target="#system_usdt_add" @click="SendEmail()">
                        <i class="fa fa-plus"></i>
                      </button>
                      <button type="button"  class="btn btn-sm mb-0" data-bs-toggle="modal" data-bs-target="#system_usdt_minus" @click="SendEmail()">
                        <i class="fa fa-minus"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label for="example-text-input" class="form-control-label">지갑 보유개수[MCS]</label>
                    <div class="input-group">
                      <input class="form-control" type="text" v-model="s_mcs_balance" readonly />
                      <button type="button"  class="btn btn-sm mb-0" @click="CheckBalance">
                        <i class="fa fa-refresh"></i>
                      </button>
                      <button type="button"  class="btn btn-sm mb-0" data-bs-toggle="modal" data-bs-target="#system_mcs_add" @click="SendEmail">
                        <i class="fa fa-plus"></i>
                      </button>
                      <button type="button"  class="btn btn-sm mb-0" data-bs-toggle="modal" data-bs-target="#system_mcs_minus" @click="SendEmail">
                        <i class="fa fa-minus"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <hr class="horizontal dark" />
              <p class="text-uppercase text-sm">접속자 정보</p>
              <div class="row">
                <div class="col-lg-6 col-12">
                  <div class="form-group">
                    <label for="example-text-input" class="form-control-label">아이디</label>
                    <div class="input-group">
                      <input class="form-control" type="text" v-model="email" readonly />
                    </div>
                  </div>
                </div>
                <div class="col-lg-6 col-12">
                  <div class="form-group">
                    <label for="example-text-input" class="form-control-label">관리자 지갑</label>
                    <input class="form-control" type="text" v-model="m_address" readonly />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-lg-4 col-12">
                  <div class="form-group">
                    <label for="example-text-input" class="form-control-label">관리자 지갑 보유개수[TRON]</label>
                    <div class="input-group">
                      <input class="form-control" type="text" v-model="m_tron_balance" readonly />
                      <button type="button"  class="btn btn-sm mb-0" @click="CheckBalance()">
                        <i class="fa fa-refresh"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 col-12">
                  <div class="form-group">
                    <label for="example-text-input" class="form-control-label">관리자 지갑 보유개수[USDT]</label>
                    <div class="input-group">
                      <input class="form-control" type="text" v-model="m_usdt_balance" readonly />
                      <button type="button"  class="btn btn-sm mb-0" @click="CheckBalance()">
                        <i class="fa fa-refresh"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 col-12">
                  <div class="form-group">
                    <label for="example-text-input" class="form-control-label">관리자 지갑 보유개수[MCS]</label>
                    <div class="input-group">
                      <input class="form-control" type="text" v-model="m_mcs_balance" readonly />
                      <button type="button"  class="btn btn-sm mb-0" @click="CheckBalance">
                        <i class="fa fa-refresh"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>
    <div class="modal" tabindex="-1" id="system_tron_add">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">TRON 금액 추가</h5>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">X</button>
          </div>
          <div class="modal-body">
            <label for="example-text-input" class="form-control-label">접속자 지갑</label>
            <input type="type" class="form-control" v-model="m_address" readonly />
            <label for="example-text-input" class="form-control-label">접속자 보유금액</label>
            <input type="type" class="form-control" v-model="m_tron_balance" readonly/>
            <label for="example-text-input" class="form-control-label">금액</label>
            <input type="type" class="form-control" v-model="add_tron_balance"/>
            <div class="col-12" v-if='auth_email ==false'>
              <div class="form-group">
                <label for="example-text-input" class="form-control-label">메일 인증코드</label>
                <div class="input-group">
                  <input class="form-control" type="text" v-model="email_code" />
                  <button type="button"  class="btn btn-sm mb-0" @click="CheckEmailAuth()">
                    <i class="fa fa-send"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">취소</button>
            <button type="button" class="btn btn-primary" data-bs-dismiss="modal" @click="SystemTRONAdd()">추가</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal" tabindex="-1" id="system_tron_minus">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">TRON 금액 차감</h5>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">X</button>
          </div>
          <div class="modal-body">
            <label for="example-text-input" class="form-control-label">시스템 지갑</label>
            <input type="type" class="form-control" v-model="s_address" readonly />
            <label for="example-text-input" class="form-control-label">시스템 보유금액</label>
            <input type="type" class="form-control" v-model="s_tron_balance" readonly/>
            <label for="example-text-input" class="form-control-label">금액</label>
            <input type="type" class="form-control" v-model="minus_tron_balance"/>
            <div class="col-12" v-if='auth_email ==false'>
              <div class="form-group">
                <label for="example-text-input" class="form-control-label">메일 인증코드</label>
                <div class="input-group">
                  <input class="form-control" type="text" v-model="email_code" />
                  <button type="button"  class="btn btn-sm mb-0" @click="CheckEmailAuth()">
                    <i class="fa fa-send"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">취소</button>
            <button type="button" class="btn btn-primary" data-bs-dismiss="modal" @click="SystemTRONMinus()">차감</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal" tabindex="-1" id="system_usdt_add">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">USDT 금액 추가</h5>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">X</button>
          </div>
          <div class="modal-body">
            <label for="example-text-input" class="form-control-label">접속자 지갑</label>
            <input type="type" class="form-control" v-model="m_address" readonly />
            <label for="example-text-input" class="form-control-label">접속자 보유금액</label>
            <input type="type" class="form-control" v-model="m_usdt_balance" readonly/>
            <label for="example-text-input" class="form-control-label">금액</label>
            <input type="type" class="form-control" v-model="add_usdt_balance"/>
            <div class="col-12" v-if='auth_email ==false'>
              <div class="form-group">
                <label for="example-text-input" class="form-control-label">메일 인증코드</label>
                <div class="input-group">
                  <input class="form-control" type="text" v-model="email_code" />
                  <button type="button"  class="btn btn-sm mb-0" @click="CheckEmailAuth()">
                    <i class="fa fa-send"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">취소</button>
            <button type="button" class="btn btn-primary" data-bs-dismiss="modal" @click="SystemUSDTAdd()">추가</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal" tabindex="-1" id="system_usdt_minus">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">USDT 금액 차감</h5>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">X</button>
          </div>
          <div class="modal-body">
            <label for="example-text-input" class="form-control-label">시스템 지갑</label>
            <input type="type" class="form-control" v-model="s_address" readonly />
            <label for="example-text-input" class="form-control-label">시스템 보유금액</label>
            <input type="type" class="form-control" v-model="s_usdt_balance" readonly/>
            <label for="example-text-input" class="form-control-label">금액</label>
            <input type="type" class="form-control" v-model="minus_usdt_balance"/>
            <div class="col-12" v-if='auth_email ==false'>
              <div class="form-group">
                <label for="example-text-input" class="form-control-label">메일 인증코드</label>
                <div class="input-group">
                  <input class="form-control" type="text" v-model="email_code" />
                  <button type="button"  class="btn btn-sm mb-0" @click="CheckEmailAuth()">
                    <i class="fa fa-send"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">취소</button>
            <button type="button" class="btn btn-primary" data-bs-dismiss="modal" @click="SystemUSDTMinus()">차감</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal" tabindex="-1" id="system_mcs_add">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">MCS 금액 추가</h5>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">X</button>
          </div>
          <div class="modal-body">
            <label for="example-text-input" class="form-control-label">접속자 지갑</label>
            <input type="type" class="form-control" v-model="m_address" readonly />
            <label for="example-text-input" class="form-control-label">접속자 보유금액</label>
            <input type="type" class="form-control" v-model="m_mcs_balance" readonly/>
            <label for="example-text-input" class="form-control-label">금액</label>
            <input type="type" class="form-control" v-model="add_mcs_balance"/>
            <div class="col-12" v-if='auth_email ==false'>
              <div class="form-group">
                <label for="example-text-input" class="form-control-label">메일 인증코드</label>
                <div class="input-group">
                  <input class="form-control" type="text" v-model="email_code" />
                  <button type="button"  class="btn btn-sm mb-0" @click="CheckEmailAuth">
                    <i class="fa fa-send"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">취소</button>
            <button type="button" class="btn btn-primary" data-bs-dismiss="modal" @click="SystemMCSAdd">추가</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal" tabindex="-1" id="system_mcs_minus">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">MCS 금액 차감</h5>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">X</button>
          </div>
          <div class="modal-body">
            <label for="example-text-input" class="form-control-label">시스템 지갑</label>
            <input type="type" class="form-control" v-model="s_address" readonly />
            <label for="example-text-input" class="form-control-label">시스템 보유금액</label>
            <input type="type" class="form-control" v-model="s_mcs_balance" readonly/>
            <label for="example-text-input" class="form-control-label">금액</label>
            <input type="type" class="form-control" v-model="minus_mcs_balance"/>
            <div class="col-12" v-if='auth_email ==false'>
              <div class="form-group">
                <label for="example-text-input" class="form-control-label">메일 인증코드</label>
                <div class="input-group">
                  <input class="form-control" type="text" v-model="email_code" />
                  <button type="button"  class="btn btn-sm mb-0" @click="CheckEmailAuth">
                    <i class="fa fa-send"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">취소</button>
            <button type="button" class="btn btn-primary" data-bs-dismiss="modal" @click="SystemMCSMinus">차감</button>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
const CryptoJS = require("crypto-js");
import {Modal} from 'bootstrap';
import { mapMutations } from "vuex";
const exactMath = require('exact-math');

export default {
  name: "profile",
  data() {
    return {
      showMenu: false,
      email_code:'',
      s_address : '',
      s_tron_balance : '',
      s_usdt_balance : '',
      s_mcs_balance : '',
      email : '',
      m_tron_balance : '',
      m_usdt_balance : '',
      m_mcs_balance : '',
      m_address : '',
      mobile :this.$store.state.mobile,
      login :this.$store.state.login,
      m_check :this.$store.state.m_system,
      show_mobile :this.$store.state.show_mobile,
      AddTRONModel : '',
      MinusTRONModel : '',
      AddUSDTModel : '',
      MinusUSDTModel : '',
      AddMCSModel : '',
      MinusMCSModel : '',
      add_tron_balance : '',
      add_usdt_balance : '',
      add_mcs_balance : '',
      minus_tron_balance : '',
      minus_usdt_balance : '',
      minus_mcs_balance : '',
      auth_email : false,
    };
  },
  components: {  },

  mounted() {
    this.AddTRONModel = new Modal(document.getElementById('system_tron_add'));
    this.MinusTRONModel = new Modal(document.getElementById('system_tron_minus'));
    this.AddUSDTModel = new Modal(document.getElementById('system_usdt_add'));
    this.MinusUSDTModel = new Modal(document.getElementById('system_usdt_minus'));
    this.AddMCSModel = new Modal(document.getElementById('system_mcs_add'));
    this.MinusMCSModel = new Modal(document.getElementById('system_mcs_minus'));
    // this.GetAdminHistroy();
    this.$store.state.showNavbar = true;
    this.$store.state.showSidenav = true;
    this.$store.state.showFooter = true;
    this.$store.state.isAbsolute = false;

    if(this.mobile ==true){
      if(this.show_mobile ==true){
        this.navbarMinimize();
      }
    }

    if(this.login){
      if(this.m_check){
        this.GetInfo();
      }else{
        this.$router.go(-1);
      }
    }else{
      this.$alert.alert("로그인 후 이용가능합니다.").then(
        ()=>{
          this.$router.push({path:"/login"})
        }
      )
    }



  },
  methods:{
    ...mapMutations(["navbarMinimize"]),
    GetInfo(){
      this.axios.post('/admin/system/GetInfo', {}).then(
        res => {
          if(res.status ==200){
            if(res.data.code=='200'){
              const e_body = res.data.body;
              const bytes  = CryptoJS.AES.decrypt(e_body,process.env.VUE_APP_SECRET_TOKEN);
              const d_res = bytes.toString(CryptoJS.enc.Utf8);
              const body = JSON.parse(d_res)
              this.email = body.email;
              this.s_address = body.s_wallet.address;
              this.s_tron_balance = body.s_wallet.tron_balance;
              this.s_usdt_balance = body.s_wallet.usdt_balance;
              this.s_mcs_balance = body.s_wallet.mcs_balance;

              this.m_address = body.m_wallet.address;
              this.m_tron_balance = body.m_wallet.tron_balance;
              this.m_usdt_balance = body.m_wallet.usdt_balance;
              this.m_mcs_balance = body.m_wallet.mcs_balance;

            }else if(res.data.code=='9999'){
              this.$store.dispatch('SETLOGOUT').then(
                ()=>{
                  window.location.href="/login";
                }
              )
            }
          }
        }
      )
    },

    CheckFeeBalance(){
      this.axios.post('/admin/master/system/fee/balance', {}).then(
        res => {
          if(res.status ==200){
            if(res.data.code=='200'){
              this.fee_balance = res.data.wallet.balance;
            }else if(res.data.code=='9999'){
              this.$store.dispatch('SETLOGOUT').then(
                ()=>{
                  window.location.href="/login";
                }
              )
            }
          }
        }
      )
    },
    CheckBalance(){
      this.axios.post('/admin/system/GetBalance', {}).then(
        res => {
          if(res.status ==200){
            if(res.data.code=='200'){
              const e_body = res.data.body;
              const bytes  = CryptoJS.AES.decrypt(e_body,process.env.VUE_APP_SECRET_TOKEN);
              const d_res = bytes.toString(CryptoJS.enc.Utf8);
              const body = JSON.parse(d_res)
              this.s_tron_balance = body.s_wallet.tron_balance;
              this.s_usdt_balance = body.s_wallet.usdt_balance;
              this.s_mcs_balance = body.s_wallet.mcs_balance;

              this.m_tron_balance = body.m_wallet.tron_balance;
              this.m_usdt_balance = body.m_wallet.usdt_balance;
              this.m_mcs_balance = body.m_wallet.mcs_balance;
            }else if(res.data.code=='9999'){
              this.$store.dispatch('SETLOGOUT').then(
                ()=>{
                  window.location.href="/login";
                }
              )
            }
          }
        }
      )
    },
    SystemTRONMinus(){
      const s_balance = this.s_tron_balance;
      const balance = this.minus_tron_balance;
      const auth = this.auth_email

      if(auth ==false){
        this.$alert.alert("인증후 진행해주세요.").then(
          ()=>{
            this.MinusTRONModel.show()
          }
        )
        return false;
      }
      const c_balance = exactMath.sub(s_balance,balance);
      if(c_balance >=0){
        const body = {balance};
        const req = CryptoJS.AES.encrypt(JSON.stringify(body),process.env.VUE_APP_SECRET_TOKEN).toString();
        this.axios.post('/admin/system/SystemTRONMinus', {req}).then(
          res => {
            if(res.status ==200){
              if(res.data.code=='200'){
                this.$alert.alert("시스템 트론을 차감하였습니다.").then(
                  ()=>{
                    this.$router.go();
                  }
                )
              }else if(res.data.code=='9999'){
                this.$store.dispatch('SETLOGOUT').then(
                  ()=>{
                    window.location.href="/login";
                  }
                )
              }
            }
          }
        )
      }

    },
    SystemTRONAdd(){
      const s_balance = this.m_tron_balance;
      const balance = this.add_tron_balance;

      const auth = this.auth_email

      if(auth ==false){
        this.$alert.alert("인증후 진행해주세요.").then(
          ()=>{
            this.AddTRONModel.show()
          }
        )
        return false;
      }
      const c_balance = exactMath.sub(s_balance,balance);
      if(c_balance >=0){
        const body = {balance};
        const req = CryptoJS.AES.encrypt(JSON.stringify(body),process.env.VUE_APP_SECRET_TOKEN).toString();
        this.axios.post('/admin/system/SystemTRONAdd', {req}).then(
          res => {
            if(res.status ==200){
              if(res.data.code=='200'){
                this.$alert.alert("시스템 트론을 증가하였습니다.").then(
                  ()=>{
                    this.$router.go();
                  }
                )
              }else if(res.data.code=='9999'){
                this.$store.dispatch('SETLOGOUT').then(
                  ()=>{
                    window.location.href="/login";
                  }
                )
              }
            }
          }
        )
      }

    },

    SystemUSDTMinus(){
      const s_balance = this.s_usdt_balance;
      const balance = this.minus_usdt_balance;
      const auth = this.auth_email

      if(auth ==false){
        this.$alert.alert("인증후 진행해주세요.").then(
          ()=>{
            this.MinusUSDTModel.show()
          }
        )
        return false;
      }
      const c_balance = exactMath.sub(s_balance,balance);
      if(c_balance >=0){
        const body = {balance};
        const req = CryptoJS.AES.encrypt(JSON.stringify(body),process.env.VUE_APP_SECRET_TOKEN).toString();
        this.axios.post('/admin/system/SystemUSDTMinus', {req}).then(
          res => {
            if(res.status ==200){
              if(res.data.code=='200'){
                this.$alert.alert("시스템 USDT을 차감하였습니다.").then(
                  ()=>{
                    this.$router.go();
                  }
                )
              }else if(res.data.code=='9999'){
                this.$store.dispatch('SETLOGOUT').then(
                  ()=>{
                    window.location.href="/login";
                  }
                )
              }
            }
          }
        )
      }

    },
    SystemUSDTAdd(){
      const s_balance = this.m_usdt_balance;
      const balance = this.add_usdt_balance;

      const auth = this.auth_email

      if(auth ==false){
        this.$alert.alert("인증후 진행해주세요.").then(
          ()=>{
            this.AddTRONModel.show()
          }
        )
        return false;
      }
      const c_balance = exactMath.sub(s_balance,balance);
      if(c_balance >=0){
        const body = {balance};
        const req = CryptoJS.AES.encrypt(JSON.stringify(body),process.env.VUE_APP_SECRET_TOKEN).toString();
        this.axios.post('/admin/system/SystemUSDTAdd', {req}).then(
          res => {
            if(res.status ==200){
              if(res.data.code=='200'){
                this.$alert.alert("시스템 USDT을 증가하였습니다.").then(
                  ()=>{
                    this.$router.go();
                  }
                )
              }else if(res.data.code=='9999'){
                this.$store.dispatch('SETLOGOUT').then(
                  ()=>{
                    window.location.href="/login";
                  }
                )
              }
            }
          }
        )
      }

    },

    SystemMCSMinus(){
      const s_balance = this.s_mcs_balance;
      const balance = this.minus_mcs_balance;
      const auth = this.auth_email

      if(auth ==false){
        this.$alert.alert("인증후 진행해주세요.").then(
            ()=>{
              this.MinusMCSModel.show()
            }
        )
        return false;
      }
      const c_balance = exactMath.sub(s_balance,balance);
      if(c_balance >=0){
        const body = {balance};
        const req = CryptoJS.AES.encrypt(JSON.stringify(body),process.env.VUE_APP_SECRET_TOKEN).toString();
        this.axios.post('/admin/system/SystemMCSMinus', {req}).then(
            res => {
              if(res.status ==200){
                if(res.data.code=='200'){
                  this.$alert.alert("시스템 MCS를 차감하였습니다.").then(
                      ()=>{
                        this.$router.go();
                      }
                  )
                }else if(res.data.code=='9999'){
                  this.$store.dispatch('SETLOGOUT').then(
                      ()=>{
                        window.location.href="/login";
                      }
                  )
                }
              }
            }
        )
      }

    },
    SystemMCSAdd(){
      const s_balance = this.m_mcs_balance;
      const balance = this.add_mcs_balance;

      const auth = this.auth_email

      if(auth ==false){
        this.$alert.alert("인증후 진행해주세요.").then(
            ()=>{
              this.AddTRONModel.show()
            }
        )
        return false;
      }
      const c_balance = exactMath.sub(s_balance,balance);
      if(c_balance >=0){
        const body = {balance};
        const req = CryptoJS.AES.encrypt(JSON.stringify(body),process.env.VUE_APP_SECRET_TOKEN).toString();
        this.axios.post('/admin/system/SystemMCSAdd', {req}).then(
            res => {
              if(res.status ==200){
                if(res.data.code=='200'){
                  this.$alert.alert("시스템 MCS를 증가하였습니다.").then(
                      ()=>{
                        this.$router.go();
                      }
                  )
                }else if(res.data.code=='9999'){
                  this.$store.dispatch('SETLOGOUT').then(
                      ()=>{
                        window.location.href="/login";
                      }
                  )
                }
              }
            }
        )
      }

    },

    SendEmail(){
      this.axios.post('/admin/system/SendEmail', {}).then(
        res => {
          if(res.status ==200){
            if(res.data.code=='200'){
              this.auth_email = false;
            }else if(res.data.code=='9999'){
              this.$store.dispatch('SETLOGOUT').then(
                ()=>{
                  window.location.href="/login";
                }
              )
            }
          }
        }
      )
    },
    CheckEmailAuth(){

      const code = this.email_code;

      if(code ==''){
        this.$alert.alert("이메일 인증코드를 입력해주세요.")
        return false;
      }
      const body = {code};

      const req = CryptoJS.AES.encrypt(JSON.stringify(body),process.env.VUE_APP_SECRET_TOKEN).toString();

      this.axios.post('/admin/system/email_certification', {req}).then(
        res => {
          if(res.status ==200){
            if(res.data.code=='200'){
              this.auth_email = true;
              this.$alert.alert("인증되었습니다.");
            }else if(res.data.code=='100'){
              this.$alert.alert("인증 코드를 다시 확인해주세요.")
            }else if(res.data.code=='9999'){
              this.$store.dispatch('SETLOGOUT').then(
                ()=>{
                  window.location.href="/login";
                }
              )
            }
          }
        }
      )
    },
  }
};
</script>
